import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiagramProject, faXmark } from "@fortawesome/free-solid-svg-icons";
import "./CardProject.css"
import CardProjectList from "./CardProjectList";
import ProjectForUserObjectList from "../../../util/ProjectForUserObjectList";

function CardProject({ idTask, idObject, idSelected, update, onlyRead, idProject }) {
    //onlyRead - Только чтение
    /*
    idObject:
        ID	Name
        1	Задача
        2	Регулярная задача
        3	Доска
        4	Проект
        5	Пользователь
        6	Регулярная задача. Трекер
    */

    const stateProject = useSelector((state) => state.projectList);
    const stateSetting = useSelector((state) => state.setting);

    const [edit, setEdit] = useState(false);
    const [projectsAccess, setProjectsAccess] = useState([]);


    useEffect(() => {
        if (stateProject.listLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listObjectLoaded.filter(a => a.id_status === 1).length > 0
            & stateProject.listUserLoaded.filter(a => a.id_status === 1).length > 0
            & idObject != null & stateSetting.user != null & stateSetting.companyService != null) {
            setProjectsAccess(ProjectForUserObjectList(stateProject.list.filter(a => a.ID_Status === 1), stateProject.listObject, stateProject.listUser, idObject, stateSetting.user.ID, stateSetting.companyService.ID_Role))
        }
    }, [stateProject.list, stateProject.listObject, stateProject.listUser, stateSetting.companyService, stateSetting.user]);

    //Выбор проекта
    function changeHandler(id, name) {
        update(id);
        setEdit(false);
    }

    return (
        <>
            {idProject === null ? (
                <div key={idProject} className="project_card_name text-danger" onClick={() => { onlyRead === false && setEdit(true) }}><FontAwesomeIcon icon={faDiagramProject} className="mr-5" /> Выберите проект...</div>
            )
                :
                (
                    <div key={idProject} className="project_card_name" onClick={() => { onlyRead === false && setEdit(true) }}><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{stateProject.list.filter(a => a.ID === idProject).length > 0 ? stateProject.list.filter(a => a.ID === idProject)[0].Name : null}</div>
                )}
            <Modal show={edit} onHide={() => setEdit(false)} >
                <Modal.Body>
                    <div className="modal_close" onClick={() => setEdit(false)}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center">Выбор проекта</div>

                    {idTask === null ?
                        (
                            <div className="form_error text-center mt-20 mb-20" >
                                Для начала работы введите название задачи
                            </div>
                        )
                        :
                        (
                            <>
                                <div>
                                    <CardProjectList id_parent={null} idSelected={idSelected} list={stateProject.list.filter(a => a.ID_Status === 1)} listAccess={projectsAccess} change={changeHandler} />
                                    {/*loading === true && (
                                        <div className="loader_01"></div>
                                    )*/}
                                </div>
                                {/*log != null && (
                                    <div className="form_error text-center mt-15">
                                        {log}
                                    </div>
                                )*/}
                            </>
                        )
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CardProject;